import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Register Service Worker in production
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");

      // If there's already a waiting SW, activate it immediately.
      if (reg.waiting) {
        reg.waiting.postMessage({ type: "SKIP_WAITING" });
      }

      // When a new SW is found, activate as soon as it's installed.
      reg.addEventListener("updatefound", () => {
        const newWorker = reg.installing;
        if (!newWorker) return;

        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            newWorker.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });

      // Reload once when the new SW takes control (prevents stale chunks causing crashes).
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });

      // Proactively check for an update shortly after load.
      setTimeout(() => {
        reg.update().catch(() => {});
      }, 3_000);
    } catch (err) {
      console.warn("SW registration failed:", err);
    }
  });
}

// Lazy-load non-critical effects CSS after first render
const loadEffects = () => import("./effects.css");
if ("requestIdleCallback" in window) {
  requestIdleCallback(loadEffects);
} else {
  setTimeout(loadEffects, 100);
}
